import { render, staticRenderFns } from "./AttachmentDetails.vue?vue&type=template&id=4bc43624&scoped=true"
import script from "./AttachmentDetails.vue?vue&type=script&lang=ts"
export * from "./AttachmentDetails.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentDetails.vue?vue&type=style&index=0&id=4bc43624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc43624",
  null
  
)

export default component.exports